import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/system';
import { Typography, Button, TextField, InputLabel, Select, MenuItem } from '@mui/material'
import SaveIcon from '@mui/icons-material/Save';
import { LocationService, TreatmentService, CountryService, MetadataService } from '../../services/DataService'
import { Translate, translate } from 'react-i18nify';
import { RequireRole } from '../../utils/RequireRole';
import { Roles } from '../../redux/actions/auth';
import AlertBox from "../../components/AlertBox"
import OutlinedInput from '@mui/material/OutlinedInput';
import Chip from '@mui/material/Chip';
import { useTheme } from '@emotion/react';
const LocationForm = props => {

    let navigate = useNavigate();
    const theme = useTheme();

    let location = props.location;
    let currentParentLocation = props.location?.parentLocation;
    let currentCountryCode = props.location?.countryCode;
    let currentRetentionPeriod = props.location?.dataRetenetionPeriod;
    let isClinicalTrialVersion = props.location?.clinicalTrial;
    let locationTags= props.location?.locationProperties?.map(property=>property.value);

    const [doneLoadingLocation, setDoneLoadingLocation] = useState(false);
    const [doneLoadingCountry, setDoneLoadingCountry] = useState(false);
    const [parentLocation, setParentLocation] = useState(currentParentLocation ? currentParentLocation?.id : "");
    const [address, setAddress] = useState(location ? location?.address : "");
    const [locationName, setLocationName] = useState(location ? location?.name : "");
    const [country, setCountry] = useState(currentCountryCode ? currentCountryCode : "");
    const [locations, setLocations] = useState([]);
    const [countries, setCountries] = useState([]);
    const [availableTags, setAvailableTags] = useState([]);
    const [tags, setTags] = useState(locationTags?locationTags:[]);
    const [dataRetentionPeriod, setDataRetentionPeriod] = useState(currentRetentionPeriod ? currentRetentionPeriod : 180);
    const [clinicalTrial, setClinicalTrial] = useState(isClinicalTrialVersion ? isClinicalTrialVersion : false);
    const [requestSubmited, setRequestSubmited] = useState(false);
    const [serviceProviderName, setServiceProviderName] = useState(() => {
        const contactName = location?.contacts?.find(contact => contact.contactTypeId === 2)?.name;
        if(contactName)
            return contactName
        return ""
    });
    const [serviceProviderValue, setServiceProviderValue] = useState( () => {
        const contactValue = location?.contacts?.find(contact => contact.contactTypeId === 2)?.value;
        if(contactValue)
            return contactValue
        return ""
    });
    const [healthcareProviderName, setHealthcareProviderName] = useState(() => {
        const contactName = location?.contacts?.find(contact => contact.contactTypeId === 1)?.name;
        if(contactName)
            return contactName
        return ""
    });
    const [healthcareProviderValue, setHealthcareProviderValue] = useState(() => {
        const contactValue = location?.contacts?.find(contact => contact.contactTypeId === 1)?.value;
        if(contactValue)
            return contactValue
        return ""
    });
    const [alertBox, setAlertBox] = useState({
        "visiblity": false,
        "statusCode": null,
        "text": null,
        "error": null
    }
    );

    

    const handleAlertBox = (visiblity, statusCode, text, error) => {
        setAlertBox({
            "visiblity": visiblity,
            "statusCode": statusCode,
            "text": text,
            "error": error
        }
        )
    }
    const dismissAlertBox=()=>{
        setAlertBox({
            "visiblity": false,
            "statusCode": null,
            "text": null,
            "error": null

        })
    }

    const handleParentLocationChange = (event, newValue) => {
        setParentLocation(newValue.props.value);
    };
    const handleCountryChange = (event, newValue) => {
        setCountry(newValue.props.value);
    };
    const handleAddressChange = (event, newValue) => {
        setAddress(event.target.value);
    };
    const handleNameChange = (event, newValue) => {
        setLocationName(event.target.value);
    };
    const handleClinicalTrial = (event, newValue) => {
        setClinicalTrial(event.target.value)
    };
    const handleRetentionPeriodChange = (event, newValue) => {
        setDataRetentionPeriod(event.target.value);
    };
    const handleServiceProviderNameChange = (event, newValue) => {
        setServiceProviderName(event.target.value);
    };
    const handleServiceProviderValueChange = (event, newValue) => {
        setServiceProviderValue(event.target.value);
    };
    const handleHealthcareProviderNameChange = (event, newValue) => {
        setHealthcareProviderName(event.target.value);
    };
    const handleHealthcareProviderValueChange = (event, newValue) => {
        setHealthcareProviderValue(event.target.value);
    };
    useEffect(() => {
        (async () => {
            let locationsResult = await LocationService.getByRoles(["Administrator"]);
            let countriesResult = await CountryService.getAll();
            let locationMetdadataResult= await MetadataService.getValuesByName("LocationProperty");
            let locationMetaData=locationMetdadataResult.data.filter(data=>data.value!="O2MATIC")
            let sorted = countriesResult.data.map((country, index) => {
                return ({ ...country, translation: translate(`Country-${country.code}`)})
            }).sort((a, b) => a.translation.localeCompare(b.translation))
            setCountries(sorted);
            setAvailableTags(locationMetaData);
            setLocations(locationsResult.data.sort((a, b) => a.name > b.name ? 1 : -1));
            setDoneLoadingLocation(true);
            setDoneLoadingCountry(true);
        })();
    }, []);

    const handleSubmit = (event) => {
        event.preventDefault();
        dismissAlertBox()
        setRequestSubmited(true)
        let locationProperties=availableTags.filter(tag =>tags.includes(tag.value));
        var body = {
            "name": locationName,
            "address": address,
            "countryCode": country,
            "parentLocationId": parentLocation,
            "dataRetentionPeriod": dataRetentionPeriod,
            "locationProperties":locationProperties,
            "contacts": [
                {
                    "contactTypeId": 2,
                    "name": serviceProviderName,
                    "value": serviceProviderValue
                },
                {
                    "contactTypeId": 1,
                    "name": healthcareProviderName,
                    "value": healthcareProviderValue
                }    
            ]
        }
        if (location.id != null ) {
            body.id = location.id;


            LocationService.update(body).then(result => {
                handleAlertBox(true, result.status, result.statusText, null) 
                setTimeout(()=>{
                    navigate("/location/" + result.data.id, { replace: true });
                },1000)

            }).catch(err => {
                setRequestSubmited(false)
                handleAlertBox(true, err?.response?.status, null, err?.response?.data?.join(",")) 
            })
        }
        else {
            LocationService.create(body).then(result => {
                handleAlertBox(true, result.status, result.statusText, null) 
                setTimeout(()=>{
                    navigate("/location/" + result.data.id, { replace: true });
                },1000)
            }).catch(err => {
                setRequestSubmited(false)
                handleAlertBox(true, err?.response?.status, null, err?.response?.data?.join(",")) 
            })
        }



    }
    const handleChange = (event) => {
        let stringRoles = event.target.value;
        setTags(stringRoles);
    };


    const renderLocationForm = (location) => {
        if (location === undefined)
            return <Typography>Loading...</Typography>
        return (
            <Box onSubmit={handleSubmit} component="form" sx={{ width: { xs: "95%", sm: "400px" }, mt: 2, display: "flex", flexDirection: "column" }}>



                <InputLabel id="nameLabel"><Translate value="Name" /></InputLabel>
                <TextField sx={{ width: "100%" }}
                    id="locationName"
                    required
                    onChange={handleNameChange}
                    value={locationName}>
                </TextField>


                <InputLabel id="addressLabel"><Translate value="Address" /></InputLabel>
                <TextField sx={{ width: "100%" }}
                    id="locationAddress"
                    required
                    inputProps={{ maxLength: 199 }}
                    onChange={handleAddressChange}
                    value={address}>
                </TextField>

                <InputLabel id="addressLabel"><Translate value="ParentLocation" /></InputLabel>
                {doneLoadingLocation ?
                    <Select
                        required
                        id="parentLocation"
                        value={parentLocation || ""}
                        onChange={handleParentLocationChange}
                    >
                        {locations.map(l => {
                            return <MenuItem key={l.id} value={l.id}>{l.name}</MenuItem>
                        })}
                    </Select>
                    : null}


                <InputLabel id="countryLabel"><Translate value="Country" /></InputLabel>


                {doneLoadingCountry ?
                    <Select
                        required
                        id="country"
                        value={country || ""}
                        onChange={handleCountryChange}
                    >
                        {countries.map(c => {
                            return <MenuItem key={c.id} value={c.code}> {c.translation} </MenuItem>
                        })}
                    </Select>
                    : null}


                <InputLabel id="retentionPeriodLabel">{<Translate value="DataRetentionPeriod" />} ({<Translate value="Days" />}) </InputLabel>
                <TextField sx={{ width: "100%" }}
                    id="dataRetentionPeriod"
                    required
                    disabled
                    type="number"
                    onChange={handleRetentionPeriodChange}
                    value={dataRetentionPeriod}>
                </TextField>

                {/*Service provider fields ---------------------------------------------*/}
                <Box sx={{mt:1 }} >
                <InputLabel id="ServiceProviderDefaultLabel" sx={{mb:1.5}}  >{<Translate value="ServiceProviderDefault" />} ({<Translate value="Optional" />}) </InputLabel>
                <TextField sx={{ width: "100%" }}
                    id="serviceProviderDefault"
                    onChange={handleServiceProviderNameChange} 
                    label={translate("Name")}
                    value={serviceProviderName}>
                </TextField>
                <TextField sx={{ width: "100%" }}
                    id="healthcareProviderDefaultLabel"
                    inputProps={{ 
                        maxLength: 16, 
                        pattern: "^[^a-zA-Z]{1,16}$" 
                    }}
                    onChange={handleServiceProviderValueChange} 
                    label={translate("ProviderValueLabel", { maxCount: 16 })}
                    value={serviceProviderValue}>
                </TextField>
                </Box>

                {/*Healthcare provider fields -------------------------------------------*/}
                <Box sx={{mt:1 }} >
                <InputLabel id="HealthcareProviderDefaultLabel" sx={{mb:1.5}} >{<Translate value="HealthcareProviderDefault" />} ({<Translate value="Optional" />}) </InputLabel>
                <TextField sx={{ width: "100%" }}
                    id="healthcareProviderDefaultLabel"
                    onChange={handleHealthcareProviderNameChange} 
                    label={translate("Name")}
                    value={healthcareProviderName}>
                </TextField>
                <TextField sx={{ width: "100%" }}
                    id="serviceProviderDefault"
                    inputProps={{ maxLength: 16, pattern: "^[^a-zA-Z]{1,16}$" }}
                    onChange={handleHealthcareProviderValueChange} 
                    label={translate("ProviderValueLabel", { maxCount: 16 })}
                    value={healthcareProviderValue}>
                </TextField>
                </Box>

                <RequireRole authorize={[Roles.CtManager]}>
                <InputLabel sx={{ mt: 0 }} id="labelSelectTags"><Translate value="SelectTags" /></InputLabel>
                <Select
                    sx={{ mb: 2, width:"100%", fontWeight: theme.typography.fontWeightRegular }}
                    labelid="labelSelectTags"
                    id="tags"
                    multiple
                    value={tags}
                    onChange={handleChange}
                    input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                    renderValue={(selected) => {
                        return (
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                {selected.map((value) => (
                                    <Chip key={value} label={value} />
                                ))}
                            </Box>
                        )
                    }}
                >
                    {availableTags.map((tag) => (
                        <MenuItem
                            key={tag.id}
                            value={tag.value}
                        >
                            {tag.value}
                        </MenuItem>
                    ))}
                </Select>

                </RequireRole>


                <Button sx={{ width: "200px", mt:2, mr: 2 }} disabled={requestSubmited} color="success" type="submit" variant='contained' startIcon={<SaveIcon />}><Translate value="Save" /> </Button>
                <AlertBox visible={alertBox.visiblity} text={alertBox.text} error={alertBox.error} statusCode={alertBox.statusCode} onHide={dismissAlertBox}/>

            </Box>


        )

    }
    return (
        <>
            {renderLocationForm(location)}
        </>
    )
}
export default LocationForm